import { CampaignUserSettingsResponse } from './campaignStore';
import { UserState, activatePendingCode, phoneContactRequest, scanQRCode } from './userStore';
import { MainButtonStore } from './mainButtonStore';

export function buildCampaignMainButton(
  settings: CampaignUserSettingsResponse,
  user: UserState
): MainButtonStore | null {
  if (settings.isActive !== true || !settings.termsConfirm) {
    return null;
  }

  const hasPhone = settings.phoneExists || user.userHasPhone;

  if (!hasPhone) {
    return {
      state: 'contact',
      text: 'Отправить мой номер',
      action: () => phoneContactRequest(),
    };
  }

  if (settings.skipQrScan) {
    return {
      state: 'scan',
      text: 'Активировать код',
      action: () => activatePendingCode(),
    };
  }

  return {
    state: 'scan',
    text: 'Сканировать QR-код',
    action: () => scanQRCode(),
  };
}
